import { render } from "./YourBidCard.vue?vue&type=template&id=70b5b8fc&scoped=true"
import script from "./YourBidCard.vue?vue&type=script&lang=js"
export * from "./YourBidCard.vue?vue&type=script&lang=js"

import "./YourBidCard.vue?vue&type=style&index=0&id=70b5b8fc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b5b8fc"]])

export default __exports__